import { Ivim } from '_store/ivim/ivimsTypes';
import { Map } from 'leaflet';
import React, { FC, ReactElement, useEffect, useRef } from 'react';

import { useClusterRefresh } from '../clustering';
import IvimMarker from './markers/IvimMarker';

const Ivims: FC<{ ivims: Ivim[]; mapRef: Map }> = ({ ivims, mapRef }): ReactElement => {
  const refreshClusters = useClusterRefresh();
  const skipFirstRefresh = useRef(true);

  useEffect(() => {
    if (skipFirstRefresh.current) {
      skipFirstRefresh.current = false;
      return;
    }
    refreshClusters();
  }, [ivims, refreshClusters]);

  return (
    <>
      {ivims.map((ivim) => (
        <IvimMarker key={ivim.id} ivim={ivim} mapRef={mapRef} />
      ))}
    </>
  );
};

export default React.memo(Ivims);
